<template>
  <v-container fluid>
    <v-layout row wrap align-center>
      <v-flex xs12 sm8 lg5 offset-sm2 offset-lg3>
        <center><img src="archivos/logo.png" width="100%"/></center>
        <br />
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-flex xs12 v-if="formulario == 1">
                <center v-if="etapa === 'I'"><h3>BIENVENIDO AL SISTEMA DE INSCRIPCIÓN</h3></center>
                <center v-if="etapa === 'R'"><h3>BIENVENIDO AL SISTEMA DE RESULTADOS</h3></center>
                <br /><br />
              </v-flex>
              <v-flex xs4 offset-xs1 v-if="formulario == 1">
                <v-card
                  class="mx-auto"
                  outline
                  elevation=10
                  height=250px
                >
                  <center>
                    <br />
                    <h4>Estudiante independiente</h4><br />
                    <v-btn v-if="etapa === 'I'" color="primary" @click="loginIngresarForm('RI')">Registrar</v-btn>
                    <v-btn v-if="etapa === 'R'" color="primary" @click="loginIngresarForm('I')">Ingresar</v-btn>
                  </center>
                </v-card>
              </v-flex>
              <v-flex xs5 offset-xs1 v-if="formulario == 1">
                <v-card
                  class="mx-auto"
                  outline
                  elevation=10
                  height=250px
                >
                  <center>
                    <br />
                    <h4>Delegación</h4><br />
                    <div v-if="etapa !== 'R'">
                      <v-btn color="primary" @click="registrarColegio()">Registrar</v-btn>
                      <h6>Obtenga su código y contraseña</h6>
                      <br />
                    </div>
                    <v-btn color="primary" @click="loginIngresarForm('D')">Ingresar</v-btn>
                    <h6>Click, si ya cuenta con código y contraseña</h6>
                  </center>
                </v-card>
              </v-flex>
              <v-flex xs12 v-if="formulario == 2">
                <h3>Delegación</h3>
                <form action="/">
                  <hr />
                  <br />
                  <v-text-field name="colegio" id="colegio" v-model="usuario" label="Ingrese su código (Recibido en su correo)" prepend-icon="location_city" required/>
                  <v-text-field type="password" name="password" id="password" v-model="clave" label="Ingrese la contraseña" prepend-icon="https" required/>
                  <div class="red--text">{{ mensaje }}</div>
                  <!-- <div class="blue--text"><b>Si no tiene usuario y contraseña haga click en Registrar</b></div> -->
                  <v-btn color="primary" @click="loginIngresar()">Ingresar</v-btn>
                  <!-- <v-btn color="primary" @click="registrarColegio()">Registrar</v-btn> -->
                </form>
              </v-flex>
              <v-flex xs12 v-if="formulario == 3">
                <h3>Estudiante</h3>
                <form action="/">
                  <hr />
                  <br />
                  <v-text-field name="colegio" id="colegio" v-model="usuario" label="Ingrese el código de estudiante si Ud. ya está registrado" prepend-icon="person" required/>
                  <v-text-field type="password" name="password" id="password" v-model="clave" label="Ingrese la contraseña" prepend-icon="https" required/>
                  <div class="red--text">{{ mensaje }}</div>
                  <!-- <div class="red--text" style="font-size: 18px;"><b>SI NO TIENE USUARIO Y CONTRASEÑA HAGA CLICK EN REGISTRAR</b></div> -->
                  <v-btn color="primary" @click="loginIngresar()">Ingresar</v-btn>
                  <!-- <v-btn color="primary" @click="registrarLibre()">Registrar</v-btn> -->
                </form>
              </v-flex>
              <v-flex xs12 v-if="formulario == 4">
                <h3>Registro de estudiante independiente</h3>
                <v-form action="/" v-model="validarInscripcion" lazy-validation>
                  <hr />
                  <br />
                  <v-text-field label="Colegio" name="colegio_insc" id="colegio_insc" v-model="libre.colegio" prepend-icon="business_center" :rules="requeridoRegla" v-on:keyup="libre.colegio = libre.colegio.toUpperCase();"/>
                  <v-select label="Tipo de colegio" name="tipo_colegio" id="tipo_colegio" :items="tiposColegio" v-model="libre.tipoColegio" prepend-icon="business_center" />
                  <v-text-field label="Apellido Paterno" name="apellido_paterno" id="apellido_paterno" v-model="libre.apellidoPaterno" prepend-icon="person" :rules="requeridoRegla" v-on:keyup="libre.apellidoPaterno = libre.apellidoPaterno.toUpperCase();"/>
                  <v-text-field label="Apellido materno" name="apellido_materno" id="apellido_materno" v-model="libre.apellidoMaterno" prepend-icon="person" :rules="requeridoRegla" v-on:keyup="libre.apellidoMaterno = libre.apellidoMaterno.toUpperCase();"/>
                  <v-text-field label="Nombres" name="nombres" id="nombres" v-model="libre.nombres" prepend-icon="person" :rules="requeridoRegla" v-on:keyup="libre.nombres = libre.nombres.toUpperCase();"/>
                  <v-text-field label="DNI" name="dni" id="dni" v-model="libre.dni" prepend-icon="person" mask="########" :rules="dniRegla"/>
                  <v-text-field label="Teléfono" name="telefono" id="telefono" v-model="libre.telefono" mask="#########" prepend-icon="person" :rules="requeridoRegla"/>
                  <v-text-field label="Correo electrónico" name="correo" id="correo" v-model="libre.correo" prepend-icon="person" :rules="emailRegla" v-on:keyup="libre.correo = libre.correo.toUpperCase();"/>
                  <v-select label="Grado" name="grado" id="grado" :items="grados" v-model="libre.grado" item-text="nombre" item-value="id" return-object prepend-icon="business_center" required/>
                  <v-select label="Departamento" name="departamento" id="departamento" v-model="libre.departamento" :items="departamentos" item-text="nombre" item-value="id" return-object prepend-icon="my_location" required/>
                  <v-select label="Provincia" name="provincia" id="provincia" v-model="libre.provincia" :items="provincias" item-text="nombre" item-value="id" return-object prepend-icon="my_location" required/>
                  <v-select label="Distrito" name="distrito" id="distrito" v-model="libre.distrito" :items="distritos" item-text="nombre" item-value="id" return-object prepend-icon="my_location" required/>
                  <v-select label="Sede" name="sede" id="sede" v-model="libre.sede" :items="sedes" item-text="nombre" item-value="id" return-object prepend-icon="my_location"/>
                  <!-- <p>Una vez registrado se le enviará su usuario y contraseña a su correo electrónico.</p> -->
                  <v-text-field label="Número de operación" v-model="libre.operacion" :rules="operacionRegla" mask="########" prepend-icon="photo"></v-text-field>
                  <v-text-field label="Monto" v-model="libre.monto" :rules="requeridoRegla" v-money prepend-icon="photo"></v-text-field>
                  <v-btn color="primary" @click="subirVoucher()">Adjuntar voucher</v-btn>
                  <p>
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onSubirVoucher"
                  >
                  <img style="max-width: 100%" :src="mostrarVoucher(voucherURL)"/>
                  </p>
                  <v-btn color="primary" :disabled="!validarInscripcion" @click="loginIngresar()">Registrar</v-btn>
                </v-form>
              </v-flex>
              <v-flex xs12 v-if="formulario == 5">
                <h3>Registro de colegio</h3>
                <v-form action="/" v-model="validarInscripcion" lazy-validation>
                  <hr />
                  <br />
                  <v-text-field label="Colegio" name="colegio_insc" id="colegio_insc" v-model="libre.colegio" prepend-icon="business_center" :rules="requeridoRegla" v-on:keyup="libre.colegio = libre.colegio.toUpperCase();"/>
                  <v-select label="Tipo de colegio" name="tipo_colegio" id="tipo_colegio" :items="tiposColegio" v-model="libre.tipoColegio" prepend-icon="business_center" />
                  <v-text-field label="Responsable - Apellido Paterno" name="apellido_paterno" id="apellido_paterno" v-model="libre.apellidoPaterno" prepend-icon="person" :rules="requeridoRegla" v-on:keyup="libre.apellidoPaterno = libre.apellidoPaterno.toUpperCase();"/>
                  <v-text-field label="Responsable - Apellido materno" name="apellido_materno" id="apellido_materno" v-model="libre.apellidoMaterno" prepend-icon="person" :rules="requeridoRegla" v-on:keyup="libre.apellidoMaterno = libre.apellidoMaterno.toUpperCase();"/>
                  <v-text-field label="Responsable - Nombres" name="nombres" id="nombres" v-model="libre.nombres" prepend-icon="person" :rules="requeridoRegla" v-on:keyup="libre.nombres = libre.nombres.toUpperCase();"/>
                  <v-text-field label="Responsable - DNI" name="dni" id="dni" v-model="libre.dni" prepend-icon="person" mask="########" :rules="dniRegla"/>
                  <v-text-field label="Teléfono" name="telefono" id="telefono" v-model="libre.telefono" mask="#########" prepend-icon="person" :rules="requeridoRegla"/>
                  <v-text-field label="Correo electrónico" name="correo" id="correo" v-model="libre.correo" prepend-icon="person" :rules="emailRegla" v-on:keyup="libre.correo = libre.correo.toUpperCase();"/>
                  <v-select label="Sede" name="sede" id="sede" v-model="libre.sede" :items="sedes" item-text="nombre" item-value="id" return-object prepend-icon="my_location"/>
                  <p>- Una vez registrado se le enviará su usuario y contraseña a su correo electrónico.</p>
                  <p style="color: red">- Los colegios deben tener al menos 5 estudiantes inscritos para poder participar como delegación.</p>
                  <v-btn color="primary" :disabled="!validarInscripcion" @click="loginIngresar()">Registrar</v-btn>
                </v-form>
              </v-flex>
            </v-card-title>
          </v-card>
          <v-flex>
            Puede descargar las bases en este enlace: <a target="_blank" href="archivos/BASES_XII_OMSIL_2019.pdf">Bases</a>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import mixin from '../mixins.js'
import ubicacion from '../ubicacion.js'
export default {
  mixins: [mixin, ubicacion],
  name: 'login',
  props: ['login', 'msgError', 'etapa'],
  data: () => ({
    usuario: '',
    clave: '',
    validarInscripcion: true,
    mensaje: '',
    tipoRegistro: 'I',
    tiposColegio: ['ESTATAL', 'PRIVADO'],
    guardar: false,
    grados: [
      {id: '3A', nombre: 'INICIAL 3 AÑOS'},
      {id: '4A', nombre: 'INICIAL 4 AÑOS'},
      {id: '5A', nombre: 'INICIAL 5 AÑOS'},
      {id: '1P', nombre: '1º PRIMARIA'},
      {id: '2P', nombre: '2º PRIMARIA'},
      {id: '3P', nombre: '3º PRIMARIA'},
      {id: '4P', nombre: '4º PRIMARIA'},
      {id: '5P', nombre: '5º PRIMARIA'},
      {id: '6P', nombre: '6º PRIMARIA'},
      {id: '1S', nombre: '1º SECUNDARIA'},
      {id: '2S', nombre: '2º SECUNDARIA'},
      {id: '3S', nombre: '3º SECUNDARIA'},
      {id: '4S', nombre: '4º SECUNDARIA'},
      {id: '5S', nombre: '5º SECUNDARIA'}
    ],
    sedes: [
      {id: '1', nombre: 'PUNO'},
      {id: '2', nombre: 'JULIACA'},
      {id: '3', nombre: 'ILAVE'}
    ],
    libre: {
      colegio: '',
      tipoColegio: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      nombres: '',
      dni: '',
      telefono: '',
      correo: '',
      grado: '',
      departamento: {id: '21', nombre: 'PUNO'},
      provincia: {id: '', nombre: ''},
      distrito: {id: '', nombre: ''},
      sede: ''
    },
    voucherURL: '',
    voucherArchivo: ''
  }),
  computed: {
    formulario () {
      if (this.$route.params.tipoIngreso === 'Independiente') {
        return 3
      } else if (this.$route.params.tipoIngreso === 'Delegacion') {
        return 2
      } else if (this.$route.params.tipoIngreso === 'Registrar') {
        this.limpiarFormulario()
        this.libre.form = 'alumno'
        return 4
      } else if (this.$route.params.tipoIngreso === 'RegistrarColegio') {
        this.limpiarFormulario()
        this.libre.form = 'colegio'
        return 5
      } else {
        return 1
      }
    },
    provincias () {
      return this.listaProvincias[this.libre.departamento.id]
    },
    distritos () {
      return this.listaDistritos[this.libre.provincia.id]
    }
  },
  methods: {
    registrarLibre: function () {
      this.$router.push('/Ingresar/Registrar')
    },
    registrarColegio: function () {
      this.$router.push('/Ingresar/RegistrarColegio')
    },
    loginIngresarForm: function (valor) {
      if (valor === 'D') {
        this.$router.push('/Ingresar/Delegacion')
      } else if (valor === 'I') {
        this.$router.push('/Ingresar/Independiente')
      } else if (valor === 'RD') {
        this.registrarColegio()
      } else if (valor === 'RI') {
        this.registrarLibre()
      }
    },
    loginIngresar: function () {
      this.mensaje = ''
      if (this.formulario === 1) {
        /* if (this.tipoRegistro === 'D') {
          this.$router.push('/Ingresar/Delegacion')
        } else {
          this.$router.push('/Ingresar/Independiente')
        } */
      } else if (this.formulario === 2) {
        const myRequest = new Request(`${process.env.API}login.php`, {method: 'POST', body: `d=${JSON.stringify({usuario: this.usuario, clave: this.clave, tipo: 'C'})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              this.mensaje = datos.m
            } else {
              this.$emit('set-token', datos.d)
            }
          })
      } else if (this.formulario === 3) {
        const myRequest = new Request(`${process.env.API}login.php`, {method: 'POST', body: `d=${JSON.stringify({usuario: this.usuario, clave: this.clave, tipo: 'A'})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              this.mensaje = datos.m
            } else {
              this.$emit('set-token', datos.d)
            }
          })
      } else if (this.formulario === 4) {
        if (this.libre.operacion === '') {
          alert('Debe ingresar el número de operación')
          return
        }
        if (this.libre.monto > 12 || this.libre.monto < 12) {
          alert('El costo de inscripción es de S/12.00')
          return
        }
        if (this.libre.voucher === undefined) {
          alert('Debe adjuntar el voucher')
          return
        }
        if (!this.guardar) {
          this.guardar = true
          const myRequest = new Request(`${process.env.API}inscribir.php`, {method: 'POST', body: `d=${JSON.stringify(this.libre)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
          return fetch(
            myRequest
          )
            .then(response => response.json())
            .then(datos => {
              console.log(datos)
              if (datos.e === 1) {
                // alert(datos.m)
                var dni = this.libre.dni
                const myRequest = new Request(`${process.env.API}login.php`, {method: 'POST', body: `d=${JSON.stringify({usuario: dni, clave: dni, tipo: 'A'})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
                return fetch(
                  myRequest
                )
                  .then(response => response.json())
                  .then(datos => {
                    if (datos.l === false) {
                      this.mensaje = datos.m
                    } else {
                      var token = datos.d
                      const myRequest = new Request(`${process.env.API}inicioApp.php`, {method: 'POST', body: `d=${JSON.stringify({tokenId: encodeURIComponent(token), local: ''})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
                      return fetch(
                        myRequest
                      )
                        .then(response => response.json())
                        .then(datos => {
                          if (datos.l) {
                            var local = datos.d.local
                            const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify({tokenId: encodeURIComponent(token), local: local, datos: {monto: this.libre.monto, operacion: this.libre.operacion, voucher: this.libre.voucher}})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
                            return fetch(
                              myRequest
                            )
                              .then(response => response.json())
                              .then(datos => {
                                if (datos.l) {
                                  const myRequest = new Request(`${process.env.API}inicio.php?mod=ficha&accion=listar`, {method: 'POST', body: `d=${JSON.stringify({tokenId: encodeURIComponent(token), local: local, datos: {tipo: 'lista', nFilas: 1000, idx: 0, ord: 0, pag: 1, grado: ''}})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
                                  return fetch(
                                    myRequest
                                  )
                                    .then(response => response.json())
                                    .then(datos => {
                                      if (datos.l) {
                                        var credencial = datos.d.data
                                        const myRequest = new Request(`${process.env.API}credencial.php?`, {method: 'POST', body: `d=${JSON.stringify({tokenId: encodeURIComponent(token), local: local, datos: {datos: credencial}})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
                                        return fetch(
                                          myRequest
                                        )
                                          .then(response => response.blob())
                                          .then(fileBlob => {
                                            var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
                                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                              window.navigator.msSaveOrOpenBlob(newBlob)
                                              return
                                            }
                                            const data = window.URL.createObjectURL(newBlob)
                                            var link = document.createElement('a')
                                            link.href = data
                                            link.target = '_blank'
                                            link.click()
                                            this.guardar = false
                                            this.limpiarFormulario()
                                          })
                                      }
                                    })
                                }
                              })
                          }
                        })
                      // local":"PUNO","datos":{"monto":"12.00","operacion":"11111113","voucher":
                    }
                  })
                // this.$router.push('/Ingresar/Independiente')
              } else {
                alert(datos.m)
              }
            })
        }
      } else if (this.formulario === 5) {
        const myRequest = new Request(`${process.env.API}inscribir.php`, {method: 'POST', body: `d=${JSON.stringify(this.libre)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.e === 1) {
              alert(datos.m)
              this.libre = {
                colegio: '',
                tipoColegio: '',
                apellidoPaterno: '',
                apellidoMaterno: '',
                nombres: '',
                dni: '',
                telefono: '',
                correo: '',
                sede: '',
                form: 'colegio'
              }
              this.$router.push('/Ingresar/Delegacion')
            } else {
              alert(datos.m)
            }
          })
      }
    },
    subirVoucher () {
      this.$refs.image.click()
    },
    registrarVoucher (url, archivo) {
      this.voucherURL = url
      this.libre.voucher = encodeURIComponent(url)
      this.voucherArchivo = archivo
    },
    mostrarVoucher (archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo)
      }
      return ''
    },
    onSubirVoucher (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          var img = document.createElement('img')
          img.src = fr.result
          img.addEventListener('load', () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)

            var MAX_WIDTH = 400
            var MAX_HEIGHT = 400
            var width = img.width
            var height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            this.registrarVoucher(canvas.toDataURL(files[0].type), files[0])
          })
        })
      } else {
        this.voucherArchivo = ''
        this.voucherURL = ''
      }
    },
    limpiarFormulario () {
      this.libre = {
        colegio: '',
        tipoColegio: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        dni: '',
        telefono: '',
        correo: '',
        grado: '',
        departamento: {id: '21', nombre: 'PUNO'},
        provincia: {id: '', nombre: ''},
        distrito: {id: '', nombre: ''},
        operacion: undefined,
        monto: '0.00',
        voucher: undefined,
        sede: '',
        form: 'alumno'
      }
      this.voucherURL = ''
      this.voucherArchivo = ''
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Ingresar.vue